<template>
    <div class="" id="SellCar">
        <mt-header fixed title="我要卖车">
            <router-link to="/" slot="left">
                <mt-button icon="back"></mt-button>
            </router-link>
        </mt-header>
        <div class="banner_car">
            <img src="static/image/banner_car.png" alt="">
        </div>
        <div class="sell_car">
            <span>67283</span>
            <em>位车主提交了卖车申请</em>
            <button @click="linkNewPage">预约卖车</button>
            <div class="but">
                <button class="float-left">免费咨询</button>
                <button class="float-right">爱车估价</button>
                <div class="clearfix"></div>
            </div>
        </div>
        <div class="line-5"></div>
        <div class="process">
            <h1>卖车流程</h1>
            <img src="static/image/process@2x.png" alt="">
        </div>
        <div class="line-5"></div>
        <div class="fast">
            <h1>
                <span></span>
                <em>卖得快</em>
            </h1>
            <img src="static/image/fast@2x.png" alt="">
            <h1>
                <span></span>
                <em>全程无忧</em>
            </h1>
            <img style="width: 62.4%; margin-left: -110px;" src="static/image/fast_1@2x.png" alt="">
        </div>
        <div class="question">
            <h1>卖车问答</h1>
            <ul>
                <li>
                    <span>1</span>
                    <em>联联车卖车模式是什么？</em>
                </li>
                <li>
                    <span>2</span>
                    <em>为什么选择在联联车卖车？</em>
                </li>
                <li>
                    <span>3</span>
                    <em>在联联车个人信息是否安全？</em>
                </li>
            </ul>
        </div>
        <div class="sell_car margin-bottom-59">
            <button @click="linkNewPage">预约卖车</button>
        </div>
        <div class="footer">
            <ul>
                <li>
                    <img src="static/image/home_off.png" alt="">
                    <span>首页</span>
                </li>
                <li>
                    <img src="static/image/buy_car_off.png" alt="">
                    <span>买车</span>
                </li>
                <li>
                    <img src="static/image/sell_car_on.png" alt="">
                    <span class="c1">卖车</span>
                </li>
                <li>
                    <img src="static/image/horsepower_off.png" alt="">
                    <span>马力</span>
                </li>
                <li>
                    <img src="static/image/my_off.png" alt="">
                    <span>我的</span>
                </li>
            </ul>
        </div>
        <!-- <mt-tabbar v-model="selected">
        <mt-tab-item id="首页">
            <img slot="icon" src="static/image/home_on.png">
            首页
        </mt-tab-item>
        <mt-tab-item id="买车">
            <img slot="icon" src="static/image/buy_car_off.png">
            买车
        </mt-tab-item>
        <mt-tab-item id="卖车">
            <img slot="icon" src="static/image/sell_car_off.png">
            卖车
        </mt-tab-item>
        <mt-tab-item id="马力">
            <img slot="icon" src="static/image/horsepower_off.png">
            马力
        </mt-tab-item>
        <mt-tab-item id="我的">
            <img slot="icon" src="static/image/my_off.png">
            我的
        </mt-tab-item>
    </mt-tabbar> -->
    </div>
</template>

<script>
import {
    Swipe,
    SwipeItem,
    Indicator,
    Toast,
    Lazyload,
    InfiniteScroll,
    Header,
    Tabbar,
    TabItem
} from "mint-ui";
import Vue from "vue";
Vue.component(Header.name, Header);
Vue.component(Swipe.name, Swipe);
Vue.component(SwipeItem.name, SwipeItem);
Vue.use(InfiniteScroll);
Vue.component(Tabbar.name, Tabbar);
Vue.component(TabItem.name, TabItem);
export default {
    name: "SellCar",
    data() {
        return {
            msg: "Welcome to Your Vue.js App"
        };
    },
     methods: {
        linkNewPage: function() {
            this.$router.push('/Evaluation')
        },
    }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.mint-header-button > a {
    color: #2c2c2c;
}
</style>



// WEBPACK FOOTER //
// src/components/SellCar.vue